import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Col} from 'reactstrap';
import Input from "reactstrap/es/Input";
import FormGroup from "reactstrap/es/FormGroup";
import Label from "reactstrap/es/Label";

import BlockUi from 'react-block-ui';
import {Loader} from "react-loaders";
import {toast} from "react-toastify";


export default class OnlyWebsite extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            data:{},
            loading: false,
            categories:[],
            category:{}
        };


        this.toggle = this.toggle.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onSend = this.onSend.bind(this);
    }



    toggle() {
        this.setState({
            modal: !this.state.modal,
            data:{
                subject: '',
            }
        });
    }

    onInputChange(event) {

        this.state.data[event.target.name] = event.target.value;
        this.setState({data: this.state.data});
    }

    notify(type, text) {
        toast[type](text);

    }
    onSend(){

        if (!this.state.data['subject'] || this.state.data['subject'] === ''){
            return this.notify('error', <span><strong>Failed!</strong> Please enter a subject.</span>)

        }

        let formData = new FormData();

        formData.append('subject', this.state.data['subject']);
        formData.append('build', JSON.stringify( this.props.prepare()));
        formData.append('category', JSON.stringify(this.state.category));


        this.setState({loading: true});

        fetch('/api/newsletter/send/builder/website', {
            credentials: 'same-origin',
            method: 'post',
            body: formData

        })
            .then(res=>res.json())
            .then(resJSON=>{

                this.setState({loading: false});
                if (resJSON.success){

                    this.setState({
                        category: {},
                        data:{
                            subject: '',
                            build: '',
                        }});

                    this.notify('success', <span><strong>Success!</strong> Newsletter posted to website!</span>);
                    this.toggle();
                } else if (resJSON['isAuthFailed']){
                    if (process.env.NODE_ENV === 'development'){
                        window.location.href = 'http://localhost:3001/api/login';
                    } else {
                        window.location.href = 'https://central.kiwischools.co.nz/api/login';
                    }
                } else {
                    this.notify('error', <span><strong>Failed!</strong> Please try again!</span>)

                }
            });
    }

    componentDidMount() {

        fetch('/api/website/wordpress/categories', {
            credentials: 'same-origin',
        })
            .then(res => res.json())
            .then(resJSON=>{

                this.setState({loading: false});
                if (resJSON.success){
                    this.setState({categories: resJSON.categories});

                    resJSON.categories.forEach((item)=>{
                        if (item.name === "Newsletters"){
                            this.setState({
                                category: {...this.state.category, [String(item.id)]: item.name}
                            });
                        }
                    })

                }else if (resJSON['isAuthFailed']){
                    if (process.env.NODE_ENV === 'development'){
                        window.location.href = 'http://localhost:3001/api/login';
                    } else {
                        window.location.href = 'https://central.kiwischools.co.nz/api/login';
                    }
                } else {
                    this.notify('error', <span><strong>Failed!</strong> Couldn't load categories</span>)
                }

            });

    }

    render() {


        return (
            <span>

                <Button style={{display:'flex', alignItems: 'center'}} block onClick={this.toggle}>
                    <i className={'lnr-exit-up'} style={{fontSize:30, marginRight:20}}/>
                    Only Website

                </Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} size="xl">
                    <ModalHeader toggle={this.toggle}>Only Upload to Website</ModalHeader>
                    <ModalBody>

                        <FormGroup>
                            <Label for="subject">Subject</Label>
                            <Input type="text" name="subject" id="subject" value={this.state.data['subject']} onChange={this.onInputChange}/>
                        </FormGroup>

                            <FormGroup>
                                <Label for={'category'}>Website Category</Label>
                                {this.state.categories.map((item) => (
                                    <FormGroup check>
                                        <Label check>
                                            <Input type="checkbox" onChange={()=>{
                                                if (Object.keys(this.state.category).indexOf(String(item.id)) > -1){

                                                    let old_category = this.state.category;
                                                    delete old_category[String(item.id)];
                                                    this.setState({
                                                        category: old_category
                                                    });
                                                } else {
                                                    this.setState({
                                                        category: {...this.state.category, [String(item.id)]: item.name}
                                                    });
                                                }

                                            }}
                                                   checked={Object.keys(this.state.category).indexOf(String(item.id)) > -1}/> {item.name}
                                        </Label>
                                    </FormGroup>
                                ))}
                            </FormGroup>

                    </ModalBody>
                    <ModalFooter>
                        <Button color="link" onClick={this.toggle}>Cancel</Button>
                        <BlockUi tag="div" blocking={this.state.loading}  style={{overflow:'hidden'}}
                                 loader={<Loader color="#ffffff" active type={'ball-clip-rotate'}/>}>
                        <Button color="primary" onClick={this.onSend}>Upload</Button>
                        </BlockUi>
                    </ModalFooter>
                </Modal>
            </span>
        );
    }
}
